import { Injectable } from '@angular/core';

import { Lang } from '../../model/orm/lang.model';
import { DataService } from '../data.service';
import { SimpleRepository } from './_simple.repository';
import { IGetallDTO } from 'src/app/model/dto/getall.dto';

@Injectable()
export class LangsRepository extends SimpleRepository<Lang> {
    constructor(protected dataService: DataService) {
        super();
        this.sortBy = "pos";
    }
    
    public load(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (new Date().getTime() - this.loadedAt < this.ttl) {
                resolve();
            } else {
                const dto: IGetallDTO = {sortBy: this.sortBy, sortDir: this.sortDir};
                this.dataService.langsAll(dto).subscribe(res => {                    
                    if (res.statusCode === 200) {
                        this.build(res.data);                       
                        this.loadedAt = new Date().getTime();
                        resolve();
                    } else {                        
                        reject(res.statusCode+": "+res.error);
                    }
                }, err => {
                    reject(err.message);
                });
            }            
        });
    }    

    public build(langs: Array<Lang> = []): void{
        this.xl = langs.length ? langs.map(d => new Lang().build(d)) : []; 
    }
}
